import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from '@/app/store';

const CORPORATE = 'corporate';
type side = 'client' | 'corporate';

interface SystemState {
  isCorporate: boolean;
  initialize: boolean;
  side: side;
  fullAccess: boolean;
  tmpAccess: boolean;
}

const initialState: SystemState = {
  isCorporate: false,
  initialize: false,
  side: 'client',
  fullAccess: false,
  tmpAccess: false,
};

export const systemSlice = createSlice({
  name: 'data',
  initialState,
  reducers: {
    determineHost: state => {
      const host = window.location.hostname.split('.')[0] as side;
      state.isCorporate = host === CORPORATE;
      state.initialize = true;
      state.side = host;
    },
    setFullAccess: state => {
      state.fullAccess = true;
      state.tmpAccess = false;
    },
    setTmpAccess: state => {
      state.fullAccess = false;
      state.tmpAccess = true;
    },
    removeAccess: state => {
      state.fullAccess = false;
      state.tmpAccess = false;
    },
  },
});

export const { determineHost, setFullAccess, setTmpAccess, removeAccess } = systemSlice.actions;

export const systemData = (state: RootState) => state.system;

export default systemSlice.reducer;
